import React from 'react'

import theme from '../../../styles/theme'

export default function CheckIcon(props) {
  return (
    <svg
      width={props.width || '10'}
      height={props.height || '10'}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 3.63905H0.958C0.974523 3.63732 0.99119 3.64048 1.00594 3.64812C1.02069 3.65576 1.03288 3.66756 1.041 3.68205C1.797 4.70405 2.553 5.72405 3.309 6.74205L4.547 8.41205C4.55493 8.42125 4.56228 8.43094 4.569 8.44105C4.612 8.35805 4.655 8.27905 4.699 8.19605C5.41433 6.83939 6.13133 5.48139 6.85 4.12205C7.56867 2.76272 8.28533 1.40439 9 0.0470525C9.00543 0.032775 9.0152 0.0205604 9.02794 0.0121288C9.04068 0.00369718 9.05574 -0.000526526 9.071 5.24846e-05C9.363 5.24846e-05 9.654 5.24846e-05 9.946 5.24846e-05H10L9.953 0.100052C9.12167 1.92872 8.28833 3.75505 7.453 5.57905C6.847 6.90639 6.24167 8.23139 5.637 9.55405C5.475 9.91005 5.309 10.2671 5.151 10.6231C5.14646 10.637 5.13718 10.649 5.12476 10.6568C5.11234 10.6647 5.09757 10.6679 5.083 10.6661H3.942C3.92548 10.6681 3.90876 10.6646 3.89446 10.6561C3.88015 10.6476 3.86909 10.6345 3.863 10.6191C2.90567 8.88572 1.947 7.15239 0.987 5.41905C0.666333 4.84105 0.344667 4.26105 0.022 3.67905C0.012922 3.66676 0.00552349 3.6533 0 3.63905"
        fill={props.color || theme.white}
      />
    </svg>
  )
}
